"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondStep = void 0;
var _react = _interopRequireDefault(require("react"));
var _qrcode = _interopRequireDefault(require("qrcode.react"));
var _reactI18next = require("react-i18next");
var _reactstrap = require("reactstrap");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Actions = require("./Actions");
var _utils = require("../../../../../../../utils");
var _ui = require("../../../../../../ui");
var _excluded = ["onPrevStepClick", "onNextStepClick", "loading", "totpKey", "totpQrUrl"];
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var QRCode = (0, _styledComponents.default)(_qrcode.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 32px auto;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin: 24px auto;\n  "]))));
var P = (0, _styledComponents.default)(_ui.P)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 23px;\n"])));
var SecondStep = function SecondStep(_ref) {
  var onPrevStepClick = _ref.onPrevStepClick,
    onNextStepClick = _ref.onNextStepClick,
    loading = _ref.loading,
    totpKey = _ref.totpKey,
    totpQrUrl = _ref.totpQrUrl,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Form, _extends({}, props, {
    className: "d-flex flex-column flex-grow-1"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "text-center mb-0"
  }, t('setUpAuthenticatorSecondStep.scanQRCode')), loading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-center flex-grow-1"
  }, /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    color: "primary"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(QRCode, {
    className: "d-block",
    size: 124,
    value: totpQrUrl
  }), /*#__PURE__*/_react.default.createElement(P, {
    className: "text-center"
  }, t('setUpAuthenticatorSecondStep.enterCodeManually')), /*#__PURE__*/_react.default.createElement(_ui.InputGroupAbsolute, null, /*#__PURE__*/_react.default.createElement(_ui.CopyInputGroupAddon, {
    value: totpKey,
    addonType: "append"
  }), /*#__PURE__*/_react.default.createElement(_ui.CopyInput, {
    value: totpKey
  }))), /*#__PURE__*/_react.default.createElement(_Actions.Actions, {
    className: "mt-auto",
    prevBtnProps: {
      onClick: onPrevStepClick
    },
    nextBtnProps: {
      onClick: onNextStepClick,
      disabled: loading
    }
  }));
};
exports.SecondStep = SecondStep;